import React, { useState } from 'react';
import moment from 'moment';
import { FaLongArrowAltUp, FaLongArrowAltDown } from 'react-icons/fa';

//components
import EnterpriseCard from './EnterpriseCard';

//hooks
import { useSortAndReverse } from '../../../../../../../../shared/hooks/useSortAndReverse';

//styles
import {
  ListPlaceholderStyles,
  TableStyles,
  TableHeaderStyles,
  TableItemStyles,
  DivStyles,
} from '../../../../../../../../SharedStyles';

//helpers
import { headerSession } from '../helpers';

const ChargingSessionEnterprise = (props) => {
  const { strings, statementDetails } = props;
  const [sessions, setSessions] = useState([]);

  const updateSortedItems = (items) => {
    items.map((i) => {
      i.time = moment(i.transactionDate).format('HH:mma');
      return i;
    });
    setSessions(items);
  };

  /**
   * Can be two of these per page for enterprise and non-enterprise
   * @param {*} sortStatus - status for the default sort
   * @param {*} dataArray - items that will be sorted
   * @param {*} headerText - strings array that will show user friendly name to map over
   * @param {*} headerConvert - converts strings in headerText array to object notation, custom function needed for this logic
   * @param {*} updateSortedItem - Function to update the current state with the sorted items
   */
  const [isActiveSort, sortReverse, changeActiveSort] = useSortAndReverse(
    'transactionDate',
    statementDetails.transactions,
    strings.sessionHeader,
    headerSession,
    updateSortedItems,
    'desc'
  );

  const tableMaxItemSize = (title) => {
    switch (true) {
      case title === 'Charger ID':
        return '95px';
      case title === 'Rate Type':
        return '95px';
      default:
        return '80px';
    }
  };

  const tableMinItemSize = (title) => {
    switch (true) {
      case title === 'Charger ID':
        return '95px';
      case title === 'Rate Type':
        return '95px';
      default:
        return 'auto';
    }
  };

  return (
    <TableStyles
      maxHeight='340px'
      minHeight={sessions.length ? sessions.length * 35 : '200px'}
      width='100%'
      overflowX='hidden'>
      <TableHeaderStyles
        borderTop='none'
        borderLeft='none'
        borderRight='none'
        width='760px'>
        {strings.sessionHeader.map((title, i) => {
          return (
            <TableItemStyles
              maxWidth={tableMaxItemSize(title)}
              minWidth={tableMinItemSize(title)}
              width='100%'
              borderRight
              key={i}
              onClick={() => {
                changeActiveSort(headerSession[title]);
              }}>
              {isActiveSort[headerSession[title]] && (
                <DivStyles
                  position='absolute'
                  left='5px'
                  top='45%'
                  transform='translate(0, -55%)'>
                  {sortReverse[headerSession[title]] ? (
                    <FaLongArrowAltDown />
                  ) : (
                    <FaLongArrowAltUp />
                  )}{' '}
                </DivStyles>
              )}
              {title}
            </TableItemStyles>
          );
        })}
      </TableHeaderStyles>
      {sessions.map((item, idx) => (
        <EnterpriseCard key={idx} statementDetails={item} />
      ))}
      {sessions.length === 0 && (
        <ListPlaceholderStyles>
          <p>{strings.noFees}</p>
        </ListPlaceholderStyles>
      )}
    </TableStyles>
  );
};

export default ChargingSessionEnterprise;
